import { SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { listPricingLevelsActions } from "@/App/actions";
import { GeneralTypes } from "@/types";

function* pricingLevelsList(data: GeneralTypes.QueryOptions): Generator {
  return yield apiService({
    url: "/pricing_level/list",
    method: "POST",
    data: data,
  });
}

export function* pricingLevelsListWorker(action: ReturnType<typeof listPricingLevelsActions.pricingLevelsList>): SagaIterator {
  const { pricingLevelsListResults } = listPricingLevelsActions;
  const { showPageAlert } = PageAlert;
  const { payload } = action;

  try {
    const { results, result_count } = yield call(pricingLevelsList, payload);
    yield put(pricingLevelsListResults({ results: results, result_count }));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* pricingLevelsListWatcher(): SagaIterator {
  yield takeEvery(ActionTypes.LIST_PRICING_LEVELS, pricingLevelsListWorker);
}
